import CfgAttributeService from "../../api/cfgAttributeService";
import {CfgAttributesNames} from "../../util/constants";
import {setApplicationError} from "../app/Slice";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";

export const getFaqContent =
    createAsyncThunk(`${SliceNames.FAQ}/getFaqContent`,
        async (_, thunkAPI) => {
            try {
                const res = await CfgAttributeService.fetchAttributeValue(CfgAttributesNames.FAQ)
                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(
                    setApplicationError({
                        isError: true,
                        statusCode: undefined
                    }))
                return thunkAPI.rejectWithValue(e)
            }
        })
